import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AOS from "aos";
import "aos/dist/aos.css";

export const MyFooter = () => {
  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: true,
    });
  }, []);

  return (
    <footer
      className="bg-dark text-white pt-5 text-center"
      style={{ borderTopLeftRadius: "24px", borderTopRightRadius: "24px" }}
    >
      <div className="footer">
        <div className="row">
          {/* Brand & Description */}
          <div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="0">
            <div className="d-flex justify-content-center">
              <a
                href="/"
                className="d-flex align-items-center mb-3 text-white text-decoration-none"
              >
                <img
                  src="/Biblivium-logo.png"
                  alt="Biblivium Logo"
                  style={{
                    width: 24,
                    height: 24,
                    objectFit: "contain",
                    marginRight: 20,
                  }}
                />
                <span className="fs-5 fw-bold">Biblivium</span>
              </a>
            </div>
            <p className="text-white-50">
              Built to help readers explore the world of literature; globally curated, elegantly presented.
            </p>
          </div>

          {/* Pages */}
          <div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="100">
            <h6 className="text-white fw-bold">PAGES</h6>
            <ul className="list-unstyled">
              <li><a href="/Literary" className="text-white text-decoration-none">Literary</a></li>
              <li><a href="/excerpts" className="text-white text-decoration-none">Excerpts</a></li>
              <li><a href="/authors" className="text-white text-decoration-none">Authors</a></li>
            </ul>
          </div>

          {/* Company */}
          <div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="200">
            <h6 className="text-white fw-bold">COMPANY</h6>
            <ul className="list-unstyled">
              <li><a href="/" className="text-white text-decoration-none">Home</a></li>
              <li><a href="/about-us" className="text-white text-decoration-none">About Us</a></li>
              <li><a href="/contact-us" className="text-white text-decoration-none">Contact</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="300">
            <h6 className="text-white fw-bold">LEGAL</h6>
            <ul className="list-unstyled">
              <li><a href="/privacy-policy" className="text-white text-decoration-none">Privacy Policy</a></li>
              <li><a href="/cookie-policy" className="text-white text-decoration-none">Cookie Policy</a></li>
              <li><a href="/terms-of-use" className="text-white text-decoration-none">Terms of Use</a></li>
            </ul>
          </div>
        </div>



        <hr className="border-secondary" />

        {/* Footer Bottom */}
        <div
          className="d-flex flex-column flex-md-row justify-content-between align-items-center py-3"
        >
          <p className="mb-2 mb-md-0 text-white-50">
            © 2026 Biblivium. A curated literary showcase by{" "}
            <a
              href="https://lonewolfwrites.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white text-decoration-none"
            >
              Lone Wolf Writes
            </a>
          </p>

          {/* Social Icons */}
          <div className="d-flex gap-3">
            <a
              href="https://www.instagram.com/liana.tudakova/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white fs-5"
            >
              <i className="bi bi-instagram"></i>
            </a>
            <a
              href="https://x.com/liana_tme"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white fs-5"
            >
              <i className="bi bi-x"></i>
            </a>
            <a
              href="https://www.linkedin.com/in/liana-tme"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white fs-5"
            >
              <i className="bi bi-linkedin"></i>
            </a>
          </div>
        </div>
      {/* <p>Bibliscend 	– from bibliophile + ascend, suggesting rising through world literature. <br />
              Biblivium 	– blending bibliophile + vivium (life), meaning “where books live.”</p> */}
      </div>
    </footer>
  );
};
